<template>
<div class="min-h-full" v-if="$store.state.authIsReady && userData">
  <div class="bg-gray-800 pb-32">
    <Disclosure as="nav" class="bg-gray-800" v-slot="{ open }">
      <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div class="border-b border-gray-700">
          <div class="flex h-16 items-center justify-between px-4 sm:px-0">
            <div class="flex items-center">
              <div class="flex-shrink-0">
                
              </div>
              <div class="hidden md:block">
                <div class=" flex items-baseline space-x-4 text-white text-medium select-none text-xs">
                    Jan-Art Sp. z o.o. <span class="opacity-20 ml-1 text-xxs">{{this.$store.state.app.version}}</span> 
                  <!-- <a v-for="item in navigation" :key="item.name" :href="item.href" :class="[item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'px-3 py-2 rounded-md text-sm font-medium']" :aria-current="item.current ? 'page' : undefined">{{ item.name }}</a> -->
                </div>
              </div>
            </div>
            <div class="hidden md:block">
              <div class="ml-4 flex items-center md:ml-6">

                <!-- Profile dropdown -->
                <Menu as="div" class="relative ml-3">
                  <div>
                    <MenuButton class="flex max-w-xs items-center rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                      <span class="sr-only">Open user menu</span>
                      <img class="h-8 w-8 rounded-full" :src="userAvatarUrl" alt="" />
                    </MenuButton>
                  </div>
                  <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                    <MenuItems class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <MenuItem >
                        <div @click.prevent="logout" class="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100">Wyloguj się</div>
                      </MenuItem>
                    </MenuItems>
                  </transition>
                </Menu>
              </div>
            </div>
            <div class="-mr-2 flex md:hidden">
              <!-- Mobile menu button -->
              <DisclosureButton class="inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                <span class="sr-only">Open main menu</span>
                <Bars3Icon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
                <XMarkIcon v-else class="block h-6 w-6" aria-hidden="true" />
              </DisclosureButton>
            </div>
          </div>
        </div>
      </div>

      <DisclosurePanel class="border-b border-gray-700 md:hidden">
        <div class="space-y-1 px-2 py-3 sm:px-3">
          
        </div>
        <div class="border-t border-gray-700 pt-4 pb-3">
          <div class="flex items-center px-5">
            <div class="flex-shrink-0">
              <img class="h-10 w-10 rounded-full" :src="userAvatarUrl" alt="" />
            </div>
            <div class="ml-3">
              <div class="text-base font-medium leading-none text-white">{{ userData.name }}</div>
              <div class="text-sm font-medium leading-none text-gray-400">{{ userData.surname }}</div>
            </div>
          </div>
          <div class="mt-3 space-y-1 px-2">
            <DisclosureButton @click.prevent="logout" class="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white">Wyloguj się</DisclosureButton>
          </div>
        </div>
      </DisclosurePanel>
    </Disclosure>
    <header class="py-10">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Transition name="hub-title" appear>
          <h1 class="text-3xl font-bold tracking-tight text-white select-none">Wybierz moduł</h1>
        </Transition>
      </div>
    </header>
  </div>
  <Transition name="hub-content" mode="out-in">
    <main v-if="!hubLoading" key="modules" class="-mt-32 max-w-7xl mx-auto">
      <TransitionGroup name="hub-card" tag="div" appear class="grid grid-cols-1 gap-4 sm:grid-cols-2 px-4 sm:px-6 lg:px-8">
      <div v-for="(mdl, index) in modules" :key="mdl.url || mdl.introduction.header" :style="{ '--hub-delay': `${Math.min(index * 70, 420)}ms` }" class="hub-module-card select-none relative flex items-center space-x-4 rounded-lg border border-gray-300 bg-white hover:bg-gray-100 px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-gray-500 focus-within:ring-offset-2 hover:shadow-lg hover:border-gray-300">
        <div class="flex-shrink-0">
          <img class="h-10 w-10 rounded-full hub-module-img" :src="mdl.introduction.img" alt="" />
        </div>
        <div class="min-w-0 flex-1">
          <router-link :to="mdl.url" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true" />
            <p class="text-sm font-medium text-gray-900">{{ mdl.introduction.header }}</p>
            <p class="truncate text-sm text-gray-500">{{ mdl.introduction.subheader }}</p>
          </router-link>
        </div>
      </div>
      </TransitionGroup>
    </main>
    <Loader v-else key="loader" />
  </Transition>
  <Transition name="hub-footer" appear>
    <div v-if="!hubLoading" class="text-gray-500 text-xs select-none flex justify-center py-4 w-full sm:fixed relative bottom-0">
      <p class="text-center text-xs text-gray-400">&copy; {{moment().year()}} Powered by <a href="https://complaia.systems/" class="transition ease-in-out duration-300 text-transparent font-medium bg-clip-text bg-gradient-to-r from-purple-500 to-blue-500 opacity-90 hover:opacity-100">Complaia Systems</a></p>
    </div>
  </Transition>
</div>
</template>

<script>
import { db } from "@/firebase/gfbconf";
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { MenuIcon as Bars3Icon, XIcon as XMarkIcon } from '@heroicons/vue/solid'
import Loader from '@/components/LoadingSpinnerHub.vue';
import moment from 'moment';
//import {db,storage} from "@/firebase/gfbconf.js"
export default {
  name: "Hub",
  data() {
    return {
      modules: [],
      hubLoading: false,
      modulesLoaded: false
    }
  },
  watch:{
      '$route'()
      {
          this.$store.commit("resetGlobalLoader");
      },
      userData: {
        immediate: true,
        async handler(userData)
        {
          if(userData && !this.modulesLoaded)
          {
            await this.getModules();
          }
        }
      }
  },
  components: {
    Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems, Bars3Icon, XMarkIcon,Loader
  },
  created() {
    this.moment = moment;
  },
  methods:
  {
    // Get menu options
    async getModules()
    {
      if(!this.userData || this.modulesLoaded || this.hubLoading) return;
      this.hubLoading = true;
      this.modules = [];
      const hubList = await db.collection("HubList").get();
      if(hubList.empty)
      {
        this.modules = [];
      }
      else
      {
        for(let i=0; i<hubList.docs.length; i++)
        {
          let moduleData = hubList.docs[i].data();
          if(this.userData.permissions[moduleData.permission] === true || this.userData.permissions.admin === true)
          {
            this.modules.push(hubList.docs[i].data());
          }
          this.modules.sort((a, b) => parseFloat(a.index) - parseFloat(b.index));
        }
      }
      setTimeout(() => {
        this.hubLoading = false;
        this.modulesLoaded = true;
      }, 1000)
    },
    async logout() {
      try {
        await this.$store.dispatch("logout");
        this.$router.push("/");
      } catch (err)
      {
        console.log(err.message);
      }
    }
  },
  computed:
  {
    userData() {
      return this.$store.state.userData || null;
    },
    userAvatarUrl() {
      const name = this.userData?.name || "";
      const surname = this.userData?.surname || "";
      return `https://api.dicebear.com/7.x/initials/svg?seed=${name} ${surname}`;
    },
  }
}
</script>
<style lang="scss" scoped>
.hub-title-enter-active {
  transition:
    opacity 360ms cubic-bezier(0.16, 1, 0.3, 1),
    transform 420ms cubic-bezier(0.16, 1, 0.3, 1),
    filter 420ms cubic-bezier(0.16, 1, 0.3, 1);
}

.hub-title-enter-from {
  opacity: 0;
  transform: translateY(-10px);
  filter: blur(4px);
}

.hub-title-enter-to {
  opacity: 1;
  transform: translateY(0);
  filter: blur(0);
}

.hub-content-enter-active,
.hub-content-leave-active {
  transition:
    opacity 220ms cubic-bezier(0.2, 0, 0, 1),
    transform 260ms cubic-bezier(0.2, 0, 0, 1);
}

.hub-content-enter-from,
.hub-content-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

.hub-card-enter-active {
  transition:
    opacity 360ms cubic-bezier(0.16, 1, 0.3, 1),
    transform 460ms cubic-bezier(0.16, 1, 0.3, 1),
    filter 420ms cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: var(--hub-delay, 0ms);
}

.hub-card-enter-from {
  opacity: 0;
  transform: translateY(14px) scale(0.985);
  filter: blur(5px);
}

.hub-card-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
  filter: blur(0);
}

.hub-module-card {
  transition:
    background-color 180ms ease,
    border-color 180ms ease,
    box-shadow 220ms ease,
    transform 180ms ease;
  will-change: transform, opacity, filter;
}

.hub-module-card:hover {
  transform: translateY(-2px);
}

.hub-module-card:active {
  transform: translateY(0) scale(0.96);
}

.hub-module-img {
  outline: 1px solid rgba(0, 0, 0, 0.1);
}

.hub-footer-enter-active {
  transition:
    opacity 360ms ease,
    transform 360ms cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: 180ms;
}

.hub-footer-enter-from {
  opacity: 0;
  transform: translateY(6px);
}

.hub-footer-enter-to {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .hub-title-enter-active,
  .hub-content-enter-active,
  .hub-content-leave-active,
  .hub-card-enter-active,
  .hub-footer-enter-active {
    transition: opacity 1ms linear;
  }

  .hub-title-enter-from,
  .hub-content-enter-from,
  .hub-content-leave-to,
  .hub-card-enter-from,
  .hub-footer-enter-from {
    opacity: 0;
    transform: none;
    filter: none;
  }
}

</style>
